import { render, staticRenderFns } from "./AccountHolderCredentials.vue?vue&type=template&id=1eada659&scoped=true"
import script from "./AccountHolderCredentials.vue?vue&type=script&lang=ts"
export * from "./AccountHolderCredentials.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderCredentials.vue?vue&type=style&index=0&id=1eada659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eada659",
  null
  
)

export default component.exports